var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRateExpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.71967 9.03033C0.426777 8.73744 0.426777 8.26256 0.71967 7.96967L3.68934 5L0.71967 2.03033C0.426777 1.73744 0.426777 1.26256 0.71967 0.96967C1.01256 0.676777 1.48744 0.676777 1.78033 0.96967L5.28033 4.46967C5.57322 4.76256 5.57322 5.23744 5.28033 5.53033L1.78033 9.03033C1.48744 9.32322 1.01256 9.32322 0.71967 9.03033Z",
    fill: "#D52377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateExpIcon);
export default __webpack_public_path__ + "static/media/rateExpIcon.d6de5543a12ba66877d00b1b2609f6c4.svg";
export { ForwardRef as ReactComponent };